import { render, staticRenderFns } from "./inquiryApplyList.vue?vue&type=template&id=beaff3c4&scoped=true"
import script from "./inquiryApplyList.vue?vue&type=script&lang=js"
export * from "./inquiryApplyList.vue?vue&type=script&lang=js"
import style0 from "./inquiryApplyList.vue?vue&type=style&index=0&id=beaff3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaff3c4",
  null
  
)

export default component.exports